import React from 'react';

const fmt = (n) => Number(n || 0).toLocaleString('pt-BR');

// Progresso do dia (limite de baús por recarga) — calculado no servidor. Tarefas ficam no ícone do card (RpTasksButton).
export const RpDaily = ({ day, perChest }) => {
  if (!day) return null;
  const capped = day.chests_day >= day.max_per_day;
  const segPct = capped ? 100 : Math.min(100, (day.coins_accum / perChest) * 100);
  return (
    <div data-testid="rp-daily">
      <div className="mt-3 flex gap-1" data-testid="rp-daily-segments" aria-label={`${day.chests_day} de ${day.max_per_day} baús hoje`}>
        {Array.from({ length: day.max_per_day }, (_, i) => (
          <div key={i} className="h-2 flex-1 overflow-hidden rounded-full bg-white/10" data-testid={`rp-daily-seg-${i + 1}`} data-state={i < day.chests_day ? 'full' : i === day.chests_day && !capped ? 'partial' : 'empty'}>
            <div className="h-full bg-gradient-to-r from-fuchsia-400 to-amber-300 transition-[width] duration-700"
              style={{ width: i < day.chests_day ? '100%' : i === day.chests_day && !capped ? `${segPct}%` : '0%' }} />
          </div>
        ))}
      </div>
      <p className="mt-1 text-[10px] text-purple-200/70" data-testid="rp-progress">
        {capped
          ? <><b className="text-amber-300">Limite de hoje atingido</b> ({day.max_per_day} baús por recarga/dia) — volta amanhã! Recargas de hoje ainda contam nas tarefas.</>
          : <>Hoje: <b className="text-white">{day.chests_day}/{day.max_per_day}</b> baús · próximo baú em {fmt(day.coins_accum)} / {fmt(perChest)} moedas</>}
      </p>
      <p className="mt-0.5 text-[10px] text-purple-300/70" data-testid="rp-orders-day">
        Recargas pagas hoje: <b className="text-purple-100">{day.orders_day || 0}</b> pedido(s) · 🪙{fmt(day.coins_day)} — conferido automaticamente com seus pedidos
      </p>
    </div>
  );
};

export default RpDaily;
